import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#283570",
      d: "M16.2 17.083q-2.355 0-4.733-1.095t-4.372-3.09q-1.988-1.995-3.083-4.37Q2.917 6.157 2.917 3.8a.86.86 0 0 1 .875-.883H6.51q.316 0 .556.206.242.206.307.508l.478 2.452q.05.341-.02.587a.87.87 0 0 1-.254.412L5.652 8.955q.465.85 1.062 1.61.597.759 1.292 1.45a14.4 14.4 0 0 0 3.127 2.368l1.87-1.886q.195-.203.474-.285a1.4 1.4 0 0 1 .578-.04l2.314.47q.315.084.515.323t.2.542v2.701q0 .376-.255.625a.86.86 0 0 1-.629.25"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "call"}) } }